import { formatValue } from "./format_value";

export function minmaxChart(config) {
  const primary = config.datasets[0];
  const secondary = config.datasets[1];

  const [ lineData1, floatingBarData1 ] = splitLineBarData(primary.data.data);
  const [ lineData2, floatingBarData2 ] = secondary ? splitLineBarData(secondary.data.data) : [];

  const datasets = [
    ...(secondary ? [{
      label: secondary.title,
      type: 'line',
      data: lineData2,
      borderWidth: 0,
      pointStyle: 'triangle',
      rotation: 180,
      pointRadius: 8,
      hoverRadius: 10,
      backgroundColor: '#e34c22',
      tooltip: {
        callbacks: {
          label: function(context) {
            return secondary.title + ': ' + formatValue(context.parsed.x, config.options.format, config.options.fractionDigits);
          }
        }
      }
    }, {
      label: '',
      type: 'bar',
      data: floatingBarData2,
      borderWidth: 0,
      backgroundColor: '#e34c22',
      tooltip: {
        callbacks: {
          label: function(context) {
            const value = context.dataset['data'][context.dataIndex];
            if (value === null) {
              return null;
            } else {
              return secondary.title + ': van ' + formatValue(Number(value[0]), config.options.format, config.options.fractionDigits) + ' tot ' + formatValue(Number(value[1]), config.options.format, config.options.fractionDigits);
            }
          }
        }
      }
    }] : []),
    ...(primary.data.median && primary.data.median.some(v => v !== null) ? [{
      label: 'mediaan',
      type: 'line',
      data: primary.data.median,
      borderWidth: 0,
      pointStyle: 'line',
      rotation: 90,
      pointRadius: 10,
      hoverRadius: 12,
      pointBackgroundColor: '#999999',
      pointBorderColor: '#999999',
      pointBorderWidth: 3,
      borderColor: '#999999',
      showLine: true,
      backgroundColor: '#999999',
      tooltip: {
        callbacks: {
          label: function(context) {
            return 'mediaan: ' + formatValue(context.parsed.x, config.options.format, config.options.fractionDigits);
          }
        }
      }
    }] : []),
    {
      // in dual mode the line provides the legend entry; in single mode the bar does
      label: secondary ? primary.title : '',
      type: 'line',
      data: lineData1,
      borderWidth: 0,
      pointStyle: 'rectRot',
      pointRadius: 8,
      hoverRadius: 10,
      backgroundColor: '#dfb829',
      tooltip: {
        callbacks: {
          label: function(context) {
            return primary.title + ': ' + formatValue(context.parsed.x, config.options.format, config.options.fractionDigits);
          }
        }
      }
    },
    {
      label: secondary ? '' : primary.title,
      type: 'bar',
      data: floatingBarData1,
      borderWidth: 0,
      backgroundColor: '#dfb829',
      tooltip: {
        callbacks: {
          label: function(context) {
            const value = context.dataset['data'][context.dataIndex];
            if (value === null) {
              return null;
            } else {
              return primary.title + ': van ' + formatValue(Number(value[0]), config.options.format, config.options.fractionDigits) + ' tot ' + formatValue(Number(value[1]), config.options.format, config.options.fractionDigits);
            }
          }
        }
      }
    }
  ];

  return {
    data: {
      labels: primary.data.labels,
      datasets: datasets
    },
    options: {
      indexAxis: 'y',
      locale: 'nl-NL',
      maintainAspectRatio: false,
      plugins: {
        legend: {
          labels: {
            filter: function(item, chart) {
              // Only show legend items with a non-empty label
              return item.text !== '';
            }
          }
        }
      },
      scales: {
        x: {
          beginAtZero: false,
          ticks: {
            callback: function(value, index, values) {
              return formatValue(value, config.options.format, config.options.fractionDigits);
            }
          }
        },
        y: {
          ticks: {
            crossAlign: 'far',
          }
        }
      },
      interaction: {
        mode: 'index',
      }
    }
  }
}

function splitLineBarData(data) {
  const lineData = [];
  const floatingBarData = [];

  data.forEach((values) => {
    const [y0, y1] = values;

    if (y0 === 0 && y1 === 0) {
      // Add null for both datasets to maintain label alignment
      lineData.push(null);
      floatingBarData.push(null);
    } else if (y0 === y1) {
      // Add to line chart if both values are equal
      lineData.push(y0);
      floatingBarData.push(null); // Maintain index alignment
    } else {
      // Add to floating bar chart if values are different
      floatingBarData.push([y0, y1]);
      lineData.push(null); // Maintain index alignment
    }
  });

  return [ lineData, floatingBarData ];
}
